/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/no-permission/app.no-permission.component.ts.
 */
import {Component} from '@angular/core';
import {AppConfigService} from '../../services/app.config.service';

/**
 * Zweck: Beschreibt class AppNoPermissionComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    // moduleId: module.id,
    selector: 'app-no-permission',
    templateUrl: 'app.no-permission.component.html',
    styleUrls: ['app.no-permission.component.scss'],
    standalone: false
})
export class AppNoPermissionComponent {
  static id = 'AppNoPermissionComponent';

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public cfg: AppConfigService) {
  }
}
